import { render, staticRenderFns } from "./vue-ladda.vue?vue&type=template&id=226359e3&"
import script from "./vue-ladda.vue?vue&type=script&lang=js&"
export * from "./vue-ladda.vue?vue&type=script&lang=js&"
import style0 from "./vue-ladda.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports